import http from "./axios";

export default {
  async addCommentToEpisode(comment) {
    try {
      return await http.post(`/api/comments`, comment);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};
